document.addEventListener('DOMContentLoaded', () => {
    let selectedLanguage = document.querySelector(`#language_selector_${document.documentElement.lang.toUpperCase()}`);
    if ( !selectedLanguage.checked && !document.querySelector('body').classList.contains('template-search')) {
        if (selectedLanguage.value === 'English') {
            selectedLanguage.value = 'Anglais';
        } else {
            selectedLanguage.value = 'Français';
        }

        selectedLanguage.click();
    }
})